import { format } from 'date-fns';
import { useConfig } from '../../../../../context/ConfigProvider/ConfigProvider';
export const useGetFormattedYearNumber = (date) => {
    const { dateFnsLocale } = useConfig();
    const year = format(date, 'yyyy', { locale: dateFnsLocale });
    return year;
};
